/* eslint-disable array-callback-return */
import React from 'react';
import { FaqItem } from '../molecules';
import { FadeUp } from 'components/organisms';
import { FaqList } from 'lib/faq';

import s from '../../styles/organisms/faq.module.scss';

export const Faq: React.FC = () => {
  return (
    <FadeUp>
      {FaqList.map((item, index) => (
        <FaqItem className={s.row} isBlack={true} key={index} question={item.question} answer={item.answer} />
      ))}
    </FadeUp>
  );
};
